<template>
  <div>
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <feather-icon
        icon="BellIcon"
        class="cursor-pointer mt-1 sm:mr-6 mr-2"
        :badge="countUnreadNotification"
      />

      <vs-dropdown-menu
        class="notification-dropdown dropdown-custom vx-navbar-dropdown"
      >
        <div class="notification-top text-center p-5 bg-primary text-white">
          <p v-if="countUnreadNotification != 0" class="text-white">
            {{ countUnreadNotification }} Notifikasi Baru
          </p>
          <p v-else class="text-white">Notifikasi</p>
        </div>

        <component
          :is="scrollbarTag"
          ref="mainSidebarPs"
          class="scroll-area--nofications-dropdown p-0 mb-10"
          :settings="settings"
          :key="$vs.rtl"
        >
          <ul class="bordered-items">
            <li
              v-if="listNotifikasi.length == 0"
              class="flex justify-between px-4 py-4 notification cursor-pointer"
            >
              <div class="flex items-start">
                <div class="mx-2">
                  <small class="text-center"
                    >Notifikasi untuk anda masih kosong</small
                  >
                </div>
              </div>
            </li>
            <li
              v-else
              v-for="(item, index) in listNotifikasi"
              :key="index"
              class="flex justify-between px-4 py-4 notification cursor-pointer"
              @click="
                handleOnClick(
                  item.id,
                  item.notifikasiable_uuid,
                  item.halaman,
                  item.is_read
                )
              "
            >
              <div class="flex items-start">
                <feather-icon
                  :icon="item.ikon"
                  :svgClasses="
                    item.is_read == 0
                      ? [`text-primary`, 'stroke-current mr-1 h-6 w-6']
                      : [`text-default`, 'stroke-current mr-1 h-6 w-6']
                  "
                >
                </feather-icon>
                <div class="mx-2">
                  <span
                    class="font-medium block notification-title"
                    :class="
                      item.is_read == 0 ? [`text-primary`] : [`text-default`]
                    "
                  >
                    {{ item.judul }}</span
                  >
                  <small>{{ item.konten.substr(0, 30) + "..." }}</small>
                </div>
              </div>
              <small class="mt-1 whitespace-no-wrap">{{
                item.created_at | indonesian_from_now_short
              }}</small>
            </li>
          </ul>
        </component>

        <div
          class="
          checkout-footer
          fixed
          bottom-0
          rounded-b-lg
          text-primary
          w-full
          p-2
          font-semibold
          text-center
          border
          border-b-0
          border-l-0
          border-r-0
          border-solid
          d-theme-border-grey-light
          cursor-pointer"
          @click="onClickAllNotifaction()"
        >
          <span>Lihat Semua Notifikasi</span>
        </div>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { digofHttp as axios } from "@/axios";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import firebase from "firebase/app";
import "firebase/messaging";
import { GET_ALL } from "@/query/notifikasi";
import { GET_COUNT } from "@/query/notifikasi";
import { UPDATE } from "@/query/notifikasi";

export default {
  components: {
    VuePerfectScrollbar
  },
  mounted() {
    this.initFCM();
  },
  data() {
    return {
      listNotifikasi: [],
      settings: {
        maxScrollbarLength: 100,
        wheelSpeed: 0.6
      }
    };
  },
  computed: {
    ...mapState({
      reloadNotification: state => state.globalApp.notification.reloadData
    }),
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    }
  },
  apollo: {
    listNotifikasi: {
      query: GET_ALL,
      update: data => data.notifikasi.data,
      variables() {
        return {
          perPage: 15,
          where: {
            AND: [
              {
                column: "PENGGUNA_ID",
                value: this.$sanctum.getUser().id
              },
              {
                column: "IS_READ",
                value: 0
              }
            ]
          },
          orderBy: [{ field: "CREATED_AT", order: "DESC" }]
        };
      },
      fetchPolicy: "cache-and-network"
    },
    countUnreadNotification: {
      query: GET_COUNT,
      update: data => {
        return data.notifikasi.paginatorInfo.total;
      },
      variables() {
        return {
          perPage: 10,
          where: {
            AND: [
              { column: "PENGGUNA_ID", value: this.$sanctum.getUser().id },
              { column: "IS_READ", value: false }
            ]
          },
          orderBy: [{ field: "CREATED_AT", order: "DESC" }]
        };
      },
      fetchPolicy: "cache-and-network"
    }
  },
  watch: {
    reloadNotification: {
      handler() {
        if (this.reloadNotification) {
          this.$apollo.queries.listNotifikasi.refetch();
          this.$apollo.queries.countUnreadNotification.refetch();
        }
      }
    }
  },
  methods: {
    initFCM() {
      let messaging = firebase.messaging();
      this.getToken(messaging);
      this.listenNotification(messaging);

      messaging.onTokenRefresh(() => {
        this.getToken(messaging);
      });
    },
    getToken(messaging) {
      messaging
        .getToken({
          vapidKey:
            "BHMpz0jK0fyfAEc7NUMhU8rTTs3jNTiADBubMZDQij2dPElOpuL33FQAkGaYZUPMiu9Cbij34rgotrvVfaF-eTA"
        })
        .then(currentToken => {
          if (currentToken) {
            this.storeFCMToken(currentToken);
          }
        })
        .catch(err => {
          console.log("An error occurred while retrieving FCM token. ", err);
        });
    },
    listenNotification(messaging) {
      // console.log("init listen firebase");
      messaging.onMessage(payload => {
        // console.log("Message received. ", payload);
        this.$vs.notify({
          title: payload.notification.title,
          text: payload.data.content,
          color: "primary",
          position: "top-right"
        });
        this.$apollo.queries.listNotifikasi.refetch();
        this.$apollo.queries.countUnreadNotification.refetch();
      });
    },
    storeFCMToken(token) {
      let data = {
        fcm_token: token,
        login_id: this.$sanctum.getUser().login_id
      };

      axios({
        method: "POST",
        url: `notification/store-device-token`,
        headers: {
          Authorization: `Bearer ${this.$sanctum.getToken()}`
        },
        data: data
      })
      .catch(error => {
        this.$vs.notify({
          color: "danger",
          title: "Terjadi Kesalahan",
          text: error
        });
      });
    },
    handleOnClick(notificationId, notificationUuid, routeName, isRead) {
      !isRead ? this.updateNotification(notificationId) : "";
      this.$router.push({
        name: routeName,
        params: { uuid: notificationUuid }
      });
      this.$apollo.queries.listNotifikasi.refetch();
      this.$apollo.queries.countUnreadNotification.refetch();
    },
    async updateNotification(notificationId) {
      await this.$apollo
        .mutate({
          mutation: UPDATE,
          variables: {
            id: notificationId,
            input: { is_read: true }
          }
        })
        .catch(error => {
          console.log(error);
          this.$vs.dialog({
            color: "danger",
            title: "Terjadi Kesalahan",
            text: "Error saat update notifikasi !"
          });
        });
    },
    onClickAllNotifaction(){
      if(this.$route.name == 'notifikasi'){
        this.$vs.notify({
          title: 'Pemberitahuan',
          text: `Anda sudah berada di halaman notifikasi.`,
          color: "warning",
          position: "top-right"
        });
      }
      else{
        this.$router.push({name : 'notifikasi'});
      }
    },
    elapsedTime(startTime) {
      const x = new Date(startTime);
      const now = new Date();
      let timeDiff = now - x;
      timeDiff /= 1000;

      const seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      const minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      const hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      const days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      const years = timeDiff;

      if (years > 0) {
        return `${years + (years > 1 ? " Years " : " Year ")}ago`;
      } else if (days > 0) {
        return `${days + (days > 1 ? " Days " : " Day ")}ago`;
      } else if (hours > 0) {
        return `${hours + (hours > 1 ? " Hrs " : " Hour ")}ago`;
      } else if (minutes > 0) {
        return `${minutes + (minutes > 1 ? " Mins " : " Min ")}ago`;
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? " sec ago" : "just now");
      }

      return "Just Now";
    },
    randomDate({ hr, min, sec }) {
      const date = new Date();

      if (hr) date.setHours(date.getHours() - hr);
      if (min) date.setMinutes(date.getMinutes() - min);
      if (sec) date.setSeconds(date.getSeconds() - sec);

      return date;
    }
  }
};
</script>
